import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { SafeAreaView, Text, View } from 'react-native';
import {
  NativeBaseProvider, Button,
} from 'native-base';
import { TextInput } from 'react-native-paper';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import { useToast } from 'react-native-toast-notifications';
import { useNavigation } from '@react-navigation/native';
import { SignUpOnInvite } from '../../gql/user/mutation';
import { styles } from '../Common.style';
import { emailSchema, passwordSchema } from '../../utils/yupSchema';
import { SCREEN_NAMES } from '../../utils/constant';

function Invite() {
  const nav = useNavigation();
  const [signUpOnInvite, { data, error }] = useMutation(SignUpOnInvite);
  const toast = useToast();

  if (error) toast.show(error.message);
  if (data?.signUpOnInvite?.status) {
    toast.show(data?.signUpOnInvite?.message);
    nav.navigate(SCREEN_NAMES.LOGIN);
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.Middle}>
        <Text style={styles.mainTitle}>Finaliser l'inscription</Text>

        <Formik
          initialValues={{
            code: '',
            email: '',
            password: '',
            confirmPassword: '',
          }}
          onSubmit={(values) => signUpOnInvite({
            variables: {
              code: values.code,
              email: values.email,
              password: values.password,
            },
          })}
          validationSchema={passwordSchema.concat(emailSchema)}
        >
          {({
            handleBlur, handleSubmit, values, errors, setFieldValue,
          }) => (
            <>
              <View style={styles.buttonStyleX}>
                <View style={styles.input}>
                  <TextInput
                    label="Email"
                    mode="outlined"
                    value={values.email}
                    onChangeText={(value) => setFieldValue('email', value)}
                    onBlur={handleBlur('email')}
                    left={<TextInput.Icon icon="email" />}
                  />
                </View>
                {!!errors.email && <Text style={styles.error}>{errors.email}</Text>}
                <View style={styles.input}>
                  <TextInput
                    label="Code reçu"
                    mode="outlined"
                    value={values.code}
                    onChangeText={(value) => setFieldValue('code', value)}
                    onBlur={handleBlur('code')}
                    left={<TextInput.Icon icon="form-textbox-lock" />}
                  />
                </View>
                <View style={styles.input}>
                  <TextInput
                    label="Saisir un mot de passe"
                    mode="outlined"
                    secureTextEntry
                    value={values.password}
                    onChangeText={(value) => setFieldValue('password', value)}
                    onBlur={handleBlur('password')}
                    left={<TextInput.Icon icon="form-textbox-password" />}
                  />
                  {!!errors.password && <Text style={styles.error}>{errors.password}</Text>}
                </View>
                <View style={styles.input}>
                  <TextInput
                    label="Confirmer votre mot de passe"
                    mode="outlined"
                    secureTextEntry
                    value={values.confirmPassword}
                    onChangeText={(value) => setFieldValue('confirmPassword', value)}
                    onBlur={handleBlur('confirmPassword')}
                    left={<TextInput.Icon icon="form-textbox-password" />}
                  />
                  {!!errors.confirmPassword && (
                    <Text style={styles.error}>{errors.confirmPassword}</Text>
                  )}
                </View>
              </View>

              {/* Button */}
              <View style={styles.buttonStyle}>
                <Button onPress={handleSubmit} style={styles.buttonDesign}>
                  Finaliser l'inscription
                </Button>
              </View>
            </>
          )}
        </Formik>

        <StatusBar />
      </View>
    </SafeAreaView>
  );
}

export default function SignUpScreen() {
  return (
    <NativeBaseProvider>
      <Invite />
    </NativeBaseProvider>
  );
}
